import { SYSTEM_ERROR } from "../config/CONSTANT";
import axios from "axios";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getAllPaymentMethode = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(
          `${BaseUrl}/api/payments`,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          resolve(res.data);
        })

        .catch((err) => {
          reject("Error in getAllfundtype axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
